import styled from "styled-components";

export const LandingBenefitsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    100.19deg,
    #f3ecff 6.96%,
    #ffffff 19.76%,
    #f3ecff 96.27%
  );
  padding: 8px 10px;
  border-radius: 12px;
`;

export const BenefitItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  gap: 8px;
`;

export const BenefitIcon = styled.img`
  width: 20px;
  height: 20px;
`;

export const BenefitContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BenefitTitle = styled.div`
  font-size: 12px;
  font-weight: 700;
`;

export const BenefitSubtitle = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: grey;
`;

export const BenefitSeparator = styled.div`
  width: 1px;
  height: 20px;
  border-left: 1px solid #ece2ff;
`;
